module.exports = __webpack_public_path__ + "img/shangkeliucheng.79a9b277.jpeg";